// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"List_actionsWrapper__fykP2"};